import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as UserService from "../../../services/UserServices";
import { useTranslation } from "react-i18next";
import UserForm from "./userForm.view";
import PATHS from "../../../constants/paths";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";

const FormFormContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // const [initValues, setInitValues] = useState({});

  // const setInitialValues = useCallback(async (data) => {
  //   const dataFinal = {
  //     name: data.name,
  //     description: data.description,
  //     document: data.document,
  //   };
  //   setInitValues(dataFinal);
  // }, []);

  // const loadData = useCallback(async () => {
  //   if (uuid) {
  //     const result = await CourseService.getCourse(uuid);
  //     if (result) {
  //       await setInitialValues(result);
  //     }
  //   }
  // }, [setInitialValues, uuid]);

  // useEffect(() => {
  //   loadData();
  // }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;
        if (uuid) {
          result = await UserService.addUser(values, uuid);
        } else {
          result = await UserService.addUser(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.course.messages.update.title");
            text = t("forms.course.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.course.messages.create.title");
            text = t("forms.course.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.course.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          navigate(PATHS.HOME);
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleOnback = () => {
    navigate(PATHS.HOME);
  };

  return (
    <UserForm
      edit={uuid ? true : false}
      // initialValues={initValues}
      onSubmit={handleSubmit}
      onBack={handleOnback}
    />
  );
};

FormFormContainer.propTypes = {
  t: PropTypes.any,
};

export default FormFormContainer;
